import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

export default function DataDeletionRequest() {
  const { user } = useAuth();
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!user) { toast.error("Please log in first."); return; }
    setBusy(true);
    const { error } = await supabase.from("child_data_requests").insert({
      parent_user_id: user.id,
      request_type: "delete",
      notes,
      status: "pending",
    });
    setBusy(false);
    if (error) toast.error(error.message);
    else { toast.success("Request submitted. We'll follow up by email."); setNotes(""); }
  };

  return (
    <div className="min-h-screen bg-background p-6 max-w-3xl mx-auto">
      <Helmet>
        <title>Data Deletion Request | HeirWise</title>
        <meta name="description" content="Request deletion of your or your child's data on HeirWise." />
      </Helmet>
      <h1 className="text-3xl font-heading font-bold mb-4">Data Deletion Request</h1>
      <p className="text-muted-foreground mb-4">Tell us which account or teen learner profile you'd like deleted. Signed-in parents can manage an eligible teen profile through <a href="/parent/privacy" className="underline">Family Privacy Controls</a>. Limited audit records and anonymized aggregate statistics may remain as described in our Privacy Policy.</p>
      <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Describe the data you want removed…" rows={6} />
      <Button className="mt-4" onClick={submit} disabled={busy || !notes.trim()}>Submit request</Button>
    </div>
  );
}